import React, { useEffect, useState } from "react";
import { Button, Form, Space, Row, Checkbox, Col } from "antd";
import { SelectWithSearch, InputText, trans, InputDate } from "@comps/components"

import { Const } from "../../constants";
import { createSelectList } from '@comps/commonFunctions';
import { makeFieldLabel } from "@utils/fieldTooltips";
import { organizationTooltips } from "../../common/organizationTooltips";
const CreateStepOne = (props) => {
  const langKey = Const["group"].lngKey
  const fieldLabel = makeFieldLabel(organizationTooltips.generic, { namespace: "generic", label: (key) => trans(`${langKey}.${key}`) });
  const formName = "creategroup";
  //========================use states start========================
  const [errors, setErrors] = useState([]);
  const [deleteAll, setForAllEmployee] = useState(false);
  const [absentPolicies, setAbsentPolicies] = useState([])
  const [missingPolicies, setMissingPolicies] = useState([])
  const [lateArrivalPolicies, setLateArrivalPolicies] = useState([])
  const [earlyLeftPolicies, setEarlyLeftPolicies] = useState([])
  const [shortDurationPolicies, setShortDurationPolicies] = useState([])
  const [relaxationPolicies, setRelaxationPolicies] = useState([])
  const [overtimePolicies, setOvertimePolicies] = useState([])
  const [cplPolicies, setCplPolicies] = useState([])
  const [leavePolicies, setLeavePolicies] = useState([])
  //=======================================
  useEffect(() => {
    setData();
    // eslint-disable-next-line
  }, [props]);

  //set props data
  //=================Submit First Step 1==============================================
  const setData = () => {
    if (props.relatedData.absent_policies) {
      setAbsentPolicies(createSelectList(props.relatedData.absent_policies))
      setMissingPolicies(createSelectList(props.relatedData.missing_policies))
      setLateArrivalPolicies(createSelectList(props.relatedData.late_arrival_policies))
      setEarlyLeftPolicies(createSelectList(props.relatedData.early_left_policies))
      setShortDurationPolicies(createSelectList(props.relatedData.short_duration_policies))
      setRelaxationPolicies(createSelectList(props.relatedData.relaxation_policies))
      setOvertimePolicies(createSelectList(props.relatedData.overtime_policies))
      setLeavePolicies(createSelectList(props.relatedData.leave_policies))
      setCplPolicies(createSelectList(props.relatedData.cpl_policies))
    }

  }

  //=====================On Submit Second Step===========================
  const onSubmitFirstStep = (data) => {
    props.response(data);
  }
  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  return (
    <>
      <Form { ...formLayout } name={ formName } onFinish={ onSubmitFirstStep } initialValues={ props.initialValues ? props.initialValues : null }>
        <Row gutter={ 30 }>
          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="name" rules={ rules.name } label={ fieldLabel("name", trans(`${langKey}.name`)) }
              className="da-mb-16"

            >
              <InputText placeholder={ trans(`${langKey}.name`) } />
            </Form.Item>
          </Col>

          {/* <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="date" rules={ rules.date } label={ fieldLabel("date", trans(`${langKey}.date`)) }
              className="da-mb-16"

            >
              <InputDate />
            </Form.Item>
          </Col> */}

          {/* <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="for_all" rules={ rules.for_all } label={ fieldLabel("for_all", trans(`${langKey}.for_all`)) }
              className="da-mb-10"
              valuePropName="checked"
            >
              <Checkbox onChange={ (e) => setForAllEmployee(e.target.checked) } />
            </Form.Item>
          </Col> */}
        </Row>

        <Row justify="end">
          <Space>
            <Button className="button-next" type="primary" htmlType="submit">
              Next
            </Button>
            {/* <CancelButton key="close_button" onClick={ () => props.onCancel(false) } /> */ }
          </Space>
        </Row>
      </Form>
    </>
  )
}
export default CreateStepOne
const rules = {
  date: [
    { required: true, message: 'Please select date' },
  ],
  name: [
    { required: true, message: 'Please enter name' },
  ],

  travel_policy_id: [
    { required: true, message: 'Please select travel policy' },
  ],

};
const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
